export { revalidateCommunity } from 'next-flight-server-reference-proxy-loader?id=4026fe8a0c2cd800e5567da57da633bb48598f6201&name=revalidateCommunity!'